import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './ZeroResultsRouterContainer';
import { ZeroDecisionResults } from './ZeroDecisionResults';
import { ZeroCommonResults } from './ZeroCommonResults';

type Props = PropsFromRedux;

const RawZeroResultsRouter: FC<Props> = ({
  enableWatchers,
  hasNoResults,
  isSearchLoading,
  searchType,
  hasDecisionRef,
  hasError,
}) => {
  if (hasError || !hasNoResults || isSearchLoading) {
    return null;
  }
  if (searchType === 'arret') {
    return (
      <ZeroDecisionResults
        searchType={searchType}
        hasDecisionRef={hasDecisionRef}
        enableWatchers={enableWatchers}
      />
    );
  }
  return <ZeroCommonResults searchType={searchType} />;
};

export const ZeroResultsRouter = Connect(RawZeroResultsRouter);
